@import '../../../stylesheets/defaults'

.mp-input-label-container
  align-items flex-end
  display flex
  flex-direction row
  flex-wrap wrap
  margin-bottom var(--input-label-margin, 5px)

  .mp-input-label
    color var(--secondary-text-color)
    font-size $font-size-medium
    font-weight $weight-medium

  .mp-input-necessary
    color var(--tertiary-text-color)
    display inline-block // Needed for capitalize to work properly
    font-size $font-size-small
    padding-left 5px
    text-transform capitalize

  .mp-input-help-icon
    align-self center
    margin-left 4px
    svg-icon-style-props('%s' % var(--tertiary-text-color), size: 18px)

  .mp-input-extra-info
    color var(--tertiary-text-color)
    font-size $font-size-small
    font-weight $weight-regular
    margin-left 4px
